import type { ComponentType } from 'react';

import type { FacetOptionsProps } from './types';

/**
 * Bespoke controls keyed on facet key. A facet with no entry renders through the generic
 * single or multi component. A renderer must select by following each option's `href`
 * and hold no selection state, so URL sync, the request and the pills keep working unchanged.
 */
export const customRenderers: { [facetKey: string]: ComponentType<FacetOptionsProps> } = {};
